<template>
  <div class="coupon-confirm-popup">
    <div class="coupon-confirm-popup-shade"></div>
    <div class="coupon-confirm-popup-content">
      <p class="coupon-confirm-popup-title">{{ languages.couponSubmitTip }}</p>
      <div class="coupon-item-wrap">
        <coupon-item
          :info="activePaytypeCouponInfo"
          :languages="languages"
        ></coupon-item>
      </div>
      <div class="coupon-confirm-popup-btn-wrap">
        <div
          class="coupon-confirm-popup-cancel btn j-click-coupon-confirm-cancel"
          @click="cancel"
        >
          {{ languages.couponCancel }}
        </div>
        <div
          class="coupon-confirm-popup-confirm btn j-click-coupon-confirm-sure"
          @click="confirm"
        >
          {{ languages.couponConfirm }}
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import CouponItem from '@components/officialWebStore/coupon/CouponItem.vue';
export default {
  name: 'couponConfirmPopup',
  props: ['languages'],
  computed: {
    activePaytypeCouponInfo() {
      return this.$store.getters.activePaytypeCouponInfo;
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    }
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.coupon-confirm-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 708px;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
  }
  &-title {
    line-height: 80px;
    height: 80px;
    text-align: center;
    font-size: 26px;
    @include g-popup-title();
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &-btn-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
  .coupon-item-wrap {
    padding: 0 20px;
    margin-top: 30px;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 24px;
    height: 80px;
    border-radius: 10px;
    padding: 0 74px;
    cursor: pointer;
  }
  &-cancel {
    color: $btnBg;
    border: 1px solid $btnBg;
    margin-right: 26px;
  }
  &-confirm {
    color: #fff;
    background: $btnBg;
  }
}

@media screen and (orientation: landscape) {
  .coupon-confirm-popup {
    &-content {
      width: $landscapePopupWidth;
    }
    &-title {
      height: 61px;
      line-height: 61px;
      font-size: 22px;
    }
  }
}
</style>
